import React from "react";
import AdminGeneralSettingsPage from "./AdminGeneralSettingsPage";

const AdminTerms = () => <AdminGeneralSettingsPage field="terms" title="Kullanım Koşulları ve Üyelik Sözleşmesi" />;

export default AdminTerms;
